import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Dashboard from './pages/Dashboard';
import SmtpSettings from './pages/SmtpSettings';
import Templates from './pages/Templates';
import Contacts from './pages/Contacts';
import Campaigns from './pages/Campaigns';
import CampaignDetail from './pages/CampaignDetail';
import EmailLogs from './pages/EmailLogs';
import WhatsAppSettings from './pages/WhatsAppSettings';
import WaTemplates from './pages/WaTemplates';
import { LayoutDashboard, Send, Users, Settings, FileText, Zap, MessageSquare, Phone, List } from 'lucide-react';

export default function App() {
  return (
    <Router>
      <Toaster position="top-right" toastOptions={{ style: { background:'#1a1a26', color:'#e8e6f0', border:'1px solid #2a2a3a', fontFamily:'DM Sans,sans-serif', fontSize:'13px' } }} />
      <div className="app">
        <aside className="sidebar">
          <div className="sidebar-brand">
            <div className="logo"><Zap size={16}/></div>
            <div>
              <span style={{fontSize:14,fontWeight:700,display:'block',letterSpacing:-.3}}>ITSYBIZZ AI</span>
              <span style={{fontSize:8.5,color:'var(--txtm)',textTransform:'uppercase',letterSpacing:1}}>Pvt. Limited</span>
            </div>
          </div>
          <nav className="sidebar-nav">
            <div className="nav-section">Overview</div>
            <NavLink to="/" end className={({isActive})=>`nav-btn ${isActive?'active':''}`}><LayoutDashboard size={18}/><span>Dashboard</span></NavLink>
            <NavLink to="/email-logs" className={({isActive})=>`nav-btn ${isActive?'active':''}`}><List size={18}/><span>Email Logs</span></NavLink>

            <div className="nav-section" style={{marginTop:8}}>Email</div>
            <NavLink to="/settings" className={({isActive})=>`nav-btn ${isActive?'active':''}`}><Settings size={18}/><span>SMTP Settings</span></NavLink>
            <NavLink to="/templates" className={({isActive})=>`nav-btn ${isActive?'active':''}`}><FileText size={18}/><span>Email Templates</span></NavLink>

            <div className="nav-section" style={{marginTop:8}}>WhatsApp</div>
            <NavLink to="/whatsapp-settings" className={({isActive})=>`nav-btn ${isActive?'active':''}`}><Phone size={18}/><span>WA Settings</span></NavLink>
            <NavLink to="/wa-templates" className={({isActive})=>`nav-btn ${isActive?'active':''}`}><MessageSquare size={18}/><span>WA Templates</span></NavLink>

            <div className="nav-section" style={{marginTop:8}}>Outreach</div>
            <NavLink to="/contacts" className={({isActive})=>`nav-btn ${isActive?'active':''}`}><Users size={18}/><span>Contacts</span></NavLink>
            <NavLink to="/campaigns" className={({isActive})=>`nav-btn ${isActive?'active':''}`}><Send size={18}/><span>Campaigns</span></NavLink>
          </nav>
          <div style={{padding:14,borderTop:'1px solid var(--bdr)',display:'flex',alignItems:'center',gap:7}}>
            <div style={{width:7,height:7,borderRadius:'50%',background:'var(--ok)'}}/>
            <span style={{fontSize:10.5,color:'var(--txtm)'}}>System Online</span>
          </div>
        </aside>
        <div className="main">
          <Routes>
            <Route path="/" element={<Dashboard/>}/>
            <Route path="/email-logs" element={<EmailLogs/>}/>
            <Route path="/settings" element={<SmtpSettings/>}/>
            <Route path="/templates" element={<Templates/>}/>
            <Route path="/whatsapp-settings" element={<WhatsAppSettings/>}/>
            <Route path="/wa-templates" element={<WaTemplates/>}/>
            <Route path="/contacts" element={<Contacts/>}/>
            <Route path="/campaigns" element={<Campaigns/>}/>
            <Route path="/campaigns/:id" element={<CampaignDetail/>}/>
          </Routes>
        </div>
      </div>
    </Router>
  );
}
